import React from 'react';
import { emojiRequested } from '../utils';
import miscUtils from '../../../utils/miscUtils';

const { currency } = miscUtils;

function OrderItem({ data }) {
    return (
        <div
            className="wrapper-order-item"
            style={{
                backgroundColor: data.preNote ? 'rgba(255,230,5,0.3)' : 'inherit',
            }}
        >
            <div className="wrapper-top-details">
                <p className="status-order mt-0 mb-2 d-flex align-items-center">
                    <span>{emojiRequested[data.requestedFrom]}</span>&nbsp;
                    {data.estado}&nbsp;{data.carreraLarga}&nbsp;{data.clienteNuevo}&nbsp;
                    {data.direccionNueva}
                </p>
                <h4 className="time-order" style={{ color: data.delivery_time ? 'red' : '' }}>
                    <i className="fa fa-clock-o"></i> {data.entrega}
                </h4>
            </div>
            <div className="wrapper-quantity-order">
                <h4 className="quantity-order">{data.cantidad}</h4>
                <span>
                    {!data.subscription ? (
                        data.paymentMethod.split('(')[0]
                    ) : (
                        <span>
                            N/A <strong>(recargas a favor)</strong>
                        </span>
                    )}
                    {data.couponId && <strong>(cupón)</strong>}
                    {data.payment_confirmation_id && (
                        <strong style={{ color: '#666' }}>({data.payment_confirmation_id})</strong>
                    )}
                    <strong>{data.vueltos ? `(${currency(data.vueltos).trim()})` : ''}</strong>
                </span>
            </div>
            <div className="d-flex align-items-center justify-content-between p-0">
                <h4
                    style={{
                        color: data.observation || data.imageObservation ? 'red' : '',
                        fontWeight: data.observation || data.imageObservation ? 'bold' : '',
                    }}
                    className="client-name-order"
                >
                    {data.cliente}
                </h4>
                <div className="p-0">
                    {data.addressInfo.publicSite && (
                        <span className="ml-2">
                            <i className="fa fa-eye"></i>
                        </span>
                    )}
                    {data.addressInfo.coolingDispenser && (
                        <span className="ml-2">
                            <i className="fa fa-snowflake-o" style={{ color: 'blue' }}></i>
                        </span>
                    )}
                </div>
            </div>
            <span style={{ color: 'red', fontSize: 12 }}>
                {data.observationImage && `(Foto)`}
                {data.observation}
            </span>
            <p className="m-0">
                {data.gpsVerified && <i className="fa fa-check-circle text-primary mr-1"></i>}
                {data.direccion}
            </p>
            <div className="wrapper-bottom-description mt-1">
                <p style={{ maxWidth: '70vw', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                    {data.quantityDescription}{' '}
                    {data.observationBotellon && `(${data.observationBotellon})`}
                    {data.isPhotoBottle && `(Ver Foto)`}
                </p>

                {data.user ? (
                    <p className="text-right">
                        <strong>{data.user.name.split(' ')[0]}</strong>
                    </p>
                ) : (
                    <p className="text-right">
                        <strong>Por asignar</strong>
                    </p>
                )}
            </div>
        </div>
    );
}

export default OrderItem;
